<div class="sb-toggle-wrapper" (click)="toggle()" [ngClass]="{'disabled' : disabled}" style="width: 104px;">
  <div class="btn-sb-toggle" [ngClass]="getClassSwitch()" style="width: 159px;">
    <span class="sb-switch-handle-on sb-switch" style="width: 53px;">{{onText}}</span>
    <span class="sb-switch-handle-label sb-switch" style="width: 53px;">&nbsp;</span>
    <span class="sb-switch-handle-off sb-switch" style="width: 53px;">{{offText}}</span>
  </div>
</div>
